var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "content" }, [
    _c("div", { staticClass: "container-fluid" }, [
      _c("div", { staticClass: "row align-items-center mb-1" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-2 offset-md-4 text-right center" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-warning btn-fill",
              attrs: { type: "submit" },
              on: { click: _vm.editArticle }
            },
            [_vm._v("Edit Article")]
          )
        ])
      ]),
      _vm._v(" "),
      _vm.article
        ? _c("div", { staticClass: "table-responsive" }, [
            _c("table", { staticClass: "table table-bordered table-light" }, [
              _c("tr", [
                _c("th", [_vm._v("Id")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.article.toneArticleId))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Published Date")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.article.datePublishFmt))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Title")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.article.articleHead))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Expert Name")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.article.authorName))])
              ]),
              _vm._v(" "),
              _c("tr"),
              _c("tr", [
                _c("th", [_vm._v("Expert Name (Optional URL)")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.article.authorUrl))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Image")]),
                _vm._v(" "),
                _c("td", [
                  _c("img", {
                    staticClass: "table-thumbnail",
                    attrs: {
                      src: _vm.article.imageUrl,
                      title: _vm.article.imageUrl
                    }
                  }),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v("\n                  (URL: "),
                  _c(
                    "a",
                    { attrs: { href: _vm.article.imageUrl, target: "_blank" } },
                    [_vm._v(" " + _vm._s(_vm.article.imageUrl) + " ")]
                  ),
                  _vm._v(")\n                ")
                ])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Paragraph 1")]),
                _vm._v(" "),
                _c("td", [
                  _c("p", {
                    domProps: { innerHTML: _vm._s(_vm.article.paragraph1) }
                  })
                ])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Paragraph 2")]),
                _vm._v(" "),
                _c("td", [
                  _c("p", {
                    domProps: { innerHTML: _vm._s(_vm.article.paragraph2) }
                  })
                ])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Paragraph 3")]),
                _vm._v(" "),
                _c("td", [
                  _c("p", {
                    domProps: { innerHTML: _vm._s(_vm.article.paragraph3) }
                  })
                ])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Paragraph 4")]),
                _vm._v(" "),
                _c("td", [
                  _c("p", {
                    domProps: { innerHTML: _vm._s(_vm.article.paragraph4) }
                  })
                ])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Paragraph 5")]),
                _vm._v(" "),
                _c("td", [
                  _c("p", {
                    domProps: { innerHTML: _vm._s(_vm.article.paragraph5) }
                  })
                ])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Paragraph 6")]),
                _vm._v(" "),
                _c("td", [
                  _c("p", {
                    domProps: { innerHTML: _vm._s(_vm.article.paragraph6) }
                  })
                ])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Paragraph 7")]),
                _vm._v(" "),
                _c("td", [
                  _c("p", {
                    domProps: { innerHTML: _vm._s(_vm.article.paragraph7) }
                  })
                ])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Paragraph 8")]),
                _vm._v(" "),
                _c("td", [
                  _c("p", {
                    domProps: { innerHTML: _vm._s(_vm.article.paragraph8) }
                  })
                ])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Paragraph 9")]),
                _vm._v(" "),
                _c("td", [
                  _c("p", {
                    domProps: { innerHTML: _vm._s(_vm.article.paragraph9) }
                  })
                ])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Paragraph 10")]),
                _vm._v(" "),
                _c("td", [
                  _c("p", {
                    domProps: { innerHTML: _vm._s(_vm.article.paragraph10) }
                  })
                ])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Status")]),
                _vm._v(" "),
                _vm.article.active
                  ? _c("td", [_vm._v("Active")])
                  : _c("td", [_vm._v("Inactive")])
              ])
            ])
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-6" }, [
      _c("div", { staticClass: "h2" }, [_vm._v("Article Details")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-55d7dc82", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55d7dc82","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Views/Articles/ArticleDetails.vue
// module id = eZEc
// module chunks = 0